<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="search-update-loan-container">
    <div class="pageHeader" id="searchUpdateLoansHeader">Search and Update Loans</div>
    <div class="warningMessage" *ngIf="warningMessage"><li>{{warningMessage}}</li></div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>


    <div class="search-criteria-text">
      <span class="selectone-text">Please select one of the search criteria below:</span>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)= "queryLoanDetails()">

      <div>
        <div class="ui-g" *ngIf="!isExternal">
          <div class="ui-g-3 lableright"> Seller Number:</div>
          <div class="ui-g-3"><input type="text" fmTextInput formControlName="sellerrNumber" [maxLength]="9"></div>
          <div class="ui-g-3 lableright">Servicer Number:</div>
          <div class="ui-g-3"><input type="text" fmTextInput formControlName="servicerNumber" [maxLength]="9"></div>
        </div>
        <div class="ui-g" *ngIf="isExternal">
          <div class="ui-g-3 lableright"> Seller Number:</div>

          <div class="ui-g-3">
            <div class="select-style">

              <fm-select
                [options]="selNumber" formControlName="sellerrNumber"
                ariaLabelledBy="default"
              ></fm-select>

            </div>

          </div>

          <div class="ui-g-3 lableright">Servicer Number:</div>


            <div class="ui-g-3">
              <fm-select
                         [options]="serNumber"
                          ariaLabelledBy="default"
                         formControlName="servicerNumber"
                         ariaLabelledBy="default"
              ></fm-select>

          </div>

        </div>


        <div class="ui-g">
          <div class="ui-g-3 lableright"> Contract Number:</div>
          <div class="ui-g-3"><input type="text" fmTextInput formControlName="ContractNumber" [maxLength]="6"></div>
          <div class="ui-g-3 lableright"> Lender Loan ID:</div>
          <div class="ui-g-3"><input type="text" fmTextInput formControlName="lenderLoanNumber" [maxLength]="15"></div>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright"> FannieMae Loan Number:</div>
          <div class="ui-g-3">
            <div class="fanniemae-loanumber">6000</div>
            <input type="text" fmTextInput formControlName="fnmeLoanNumber" id="searchLoanNumber" [maxLength]="6" class="u-width-175"></div>
          <div class="ui-g-3 lableright"> Loan Status:</div>
          <div class="ui-g-3">
            <div class="select-style">
              <fm-select
                [options]="loanStatus"
                ariaLabelledBy="default"
                formControlName="loanStatus"
              ></fm-select>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright"> Purchased From:</div>
          <div class="ui-g-3">
            <fm-calendar dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="PurchaseFromDt"
                         [yearNavigator]="true" [monthNavigator]="true" [showClear]="true"></fm-calendar>
          </div>
          <div class="ui-g-3 lableright"> Purchased To:</div>
          <div class="ui-g-3">
            <fm-calendar dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="PurchaseToDt"
                         [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright"> Product Code:</div>
          <div class="ui-g-3">
            <fm-select
              [options]="productCode"
              ariaLabelledBy="default"
              formControlName="ProductCd"
            ></fm-select>
          </div>
          <div class="ui-g-3 lableright"> User ID:</div>
          <div class="ui-g-3"><input type="text" formControlName="userID" [maxLength]="8" fmTextInput></div>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright"> Sort Order:</div>
          <div class="ui-g-3">
            <fm-select
              [options]="sortOrder"
              ariaLabelledBy="default"
              formControlName="SortOrder"
            ></fm-select>
          </div>
          <div class="ui-g-3"></div>
          <div class="ui-g-3"></div>
        </div>

        <div class="ui-g">
          <div class="ui-g-6">
            <button fmButton type="submit" [primary]="true" [small]="true" label="Search"
                    class="buttonmargin"></button>
            <button fmButton type="button" label="Clear" [small]="true" (click)="onClear()"
                    class="buttonmargin"></button>
            <button fmButton type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                    class="buttonmargin"></button>
          </div>
          <div class="ui-g-6"></div>
        </div>
      </div>

    </form>
  </div>
</div>



